"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return AuthInput;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _reactauthcodeinput = /*#__PURE__*/ _interop_require_default(require("react-auth-code-input"));
var _styled = /*#__PURE__*/ _interop_require_default(require("@emotion/styled"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _tagged_template_literal_loose(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    strings.raw = raw;
    return strings;
}
function _templateObject() {
    var data = _tagged_template_literal_loose([
        "\n  input {\n    font-weight: 600;\n    font-size: 18px;\n    width: 48px;\n    height: 48px;\n    padding: 0;\n    font-size: 1rem;\n    text-align: center;\n    margin-right: 8px;\n    text-transform: uppercase;\n    border-radius: 8px;\n    color: #494949;\n    border: 1px solid #d6d6d6;\n    background: #fff;\n    background-clip: padding-box;\n  }\n\n  input:last-child {\n    margin-right: 0px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var CodeWrapper = _styled.default.div(_templateObject());
function AuthInput(param) {
    var handleCodeChange = param.handleCodeChange;
    var handleOnChange = function(res) {
        handleCodeChange(res);
    };
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_jsxruntime.Fragment, {
        children: /*#__PURE__*/ (0, _jsxruntime.jsx)(CodeWrapper, {
            children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_reactauthcodeinput.default, {
                onChange: handleOnChange,
                placeholder: "-"
            })
        })
    });
}
